<template>
  <div class="dp-root">
    <!-- TOP BAR -->
    <div class="dp-topbar">
      <div class="dp-brand">
        <div class="dp-brand-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
            <line x1="7" y1="7" x2="7.01" y2="7"/>
          </svg>
        </div>
        <div>
          <div class="dp-brand-title">Descontos</div>
          <div class="dp-brand-sub">{{ total }} clientes</div>
        </div>
      </div>

      <div class="dp-search-wrap">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
        <input
          :value="search"
          class="dp-search"
          placeholder="Pesquisar por nome ou QR code…"
          @input="$emit('update:search', $event.target.value)"
        />
        <button v-if="search" class="dp-search-x" @click="$emit('update:search', '')">✕</button>
      </div>

      <button class="dp-hist-btn" @click="$emit('open-historico')">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
        Histórico
      </button>
    </div>

    <!-- FILTROS DE TIER -->
    <div class="dp-filters">
      <span class="dp-filters-label">Mostrar clientes com:</span>
      <div class="dp-tier-pills">
        <button
          class="dp-tier-pill"
          :class="{ active: activeTier === null }"
          @click="$emit('update:activeTier', null)"
        >Todos</button>
        <button
          v-for="t in tiers" :key="t.key"
          class="dp-tier-pill"
          :class="{ active: activeTier === t.key }"
          :style="activeTier === t.key ? `background:${t.color};border-color:${t.color};color:#fff` : `border-color:${t.color}20;color:${t.color}`"
          @click="$emit('update:activeTier', activeTier === t.key ? null : t.key)"
        >
          <span class="dp-tier-dot" :style="`background:${t.color}`"></span>
          {{ t.label }}
        </button>
      </div>

      <div class="dp-sel-actions">
        <button class="dp-sel-btn" @click="$emit('toggle-page-select')">
          <span class="dp-checkbox" :class="{ on: allPageSelected, partial: somePageSelected }">
            <svg v-if="allPageSelected" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="4"><path d="M20 6 9 17l-5-5"/></svg>
          </span>
          {{ allPageSelected ? 'Desmarcar página' : 'Selecionar página' }}
        </button>
        <button class="dp-sel-all-btn" :disabled="loadingSelectAll" @click="$emit('select-all-filtered')">
          <span v-if="loadingSelectAll" class="dp-spinner"></span>
          <template v-else>Selecionar todos <strong>({{ total }})</strong></template>
        </button>
      </div>
    </div>

    <!-- BULK BAR — só aparece quando há seleção -->
    <transition name="dp-slide">
      <div v-if="totalSelected > 0" class="dp-bulk">
        <div class="dp-bulk-left">
          <div class="dp-bulk-pill">
            <strong>{{ totalSelected }}</strong>
            cliente{{ totalSelected !== 1 ? 's' : '' }} selecionado{{ totalSelected !== 1 ? 's' : '' }}
            <button class="dp-bulk-x" @click="$emit('clear-selection')">✕</button>
          </div>
        </div>

        <div class="dp-bulk-center">
          <span class="dp-bulk-label">Aplicar desconto de</span>
          <div class="dp-bulk-pct">
            <input
              :value="bulkDesconto"
              type="number" min="0" max="100"
              class="dp-bulk-input"
              placeholder="0"
              @input="$emit('update:bulkDesconto', $event.target.value)"
            />
            <span>%</span>
          </div>
          <span class="dp-bulk-label">em</span>
          <el-select
            :value="bulkRestaurantes"
            multiple collapse-tags
            placeholder="todos os restaurantes"
            size="small"
            class="dp-bulk-rest"
            @input="$emit('update:bulkRestaurantes', $event)"
          >
            <el-option v-for="r in restaurantes" :key="r.id" :label="r.nome" :value="r.id"/>
          </el-select>
        </div>

        <div class="dp-bulk-right">
          <button
            class="dp-bulk-apply"
            :disabled="!bulkDesconto && bulkDesconto !== 0"
            @click="$emit('confirmar-bulk')"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>
            Aplicar
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { TIERS } from "./descontos.utils.js";
export default {
  name: "DescontosPainel",
  components: { [Select.name]: Select, [Option.name]: Option },
  props: {
    total:            { type: Number,  default: 0 },
    restaurantes:     { type: Array,   default: () => [] },
    search:           { type: String,  default: "" },
    activeTier:       { default: null },
    allPageSelected:  { type: Boolean, default: false },
    somePageSelected: { type: Boolean, default: false },
    totalSelected:    { type: Number,  default: 0 },
    loadingSelectAll: { type: Boolean, default: false },
    bulkDesconto:     { default: null },
    bulkRestaurantes: { type: Array,   default: () => [] },
  },
  data() { return { tiers: TIERS }; },
};
</script>

<style scoped>
.dp-root {
  background: #fff;
  border-bottom: 1px solid #f0ece8;
  font-family: 'DM Sans','Outfit',system-ui,sans-serif;
}

/* TOP BAR */
.dp-topbar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 28px 14px;
  flex-wrap: wrap;
}

.dp-brand {
  display: flex;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
}
.dp-brand-icon {
  width: 40px; height: 40px;
  background: #ff825d;
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  color: #fff;
  box-shadow: 0 4px 12px rgba(255,130,93,.3);
}
.dp-brand-title { font-size: 16px; font-weight: 700; color: #1a1210; letter-spacing: -.3px; }
.dp-brand-sub   { font-size: 12px; color: #b0a8a0; margin-top: 1px; }

.dp-search-wrap {
  flex: 1; max-width: 380px;
  display: flex; align-items: center; gap: 9px;
  background: #f7f4f1;
  border-radius: 12px;
  padding: 10px 14px;
  color: #b0a8a0;
  transition: background .15s;
}
.dp-search-wrap:focus-within { background: #f0ece8; }
.dp-search {
  flex: 1; background: none; border: none; outline: none;
  font-size: 14px; color: #1a1210;
}
.dp-search::placeholder { color: #b0a8a0; }
.dp-search-x {
  background: none; border: none; cursor: pointer;
  color: #c0b8b0; font-size: 12px; padding: 0;
  transition: color .15s;
}
.dp-search-x:hover { color: #6b6460; }

.dp-hist-btn {
  display: flex; align-items: center; gap: 7px;
  padding: 9px 16px;
  background: #f7f4f1;
  border: none; border-radius: 10px;
  font-size: 13.5px; color: #6b6460; cursor: pointer;
  transition: all .15s;
  white-space: nowrap;
  margin-left: auto;
}
.dp-hist-btn:hover { background: #f0ece8; color: #1a1210; }

/* FILTERS */
.dp-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 28px 16px;
  flex-wrap: wrap;
}
.dp-filters-label {
  font-size: 12px;
  color: #b0a8a0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .05em;
  white-space: nowrap;
  flex-shrink: 0;
}
.dp-tier-pills { display: flex; gap: 6px; flex-wrap: wrap; }
.dp-tier-pill {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1.5px solid #e8e4e0;
  background: transparent;
  font-size: 13px; color: #7a736e;
  cursor: pointer;
  transition: all .15s;
  white-space: nowrap;
}
.dp-tier-pill:hover { border-color: #d0c8c0; color: #1a1210; }
.dp-tier-pill.active { font-weight: 600; }
.dp-tier-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }

.dp-sel-actions {
  display: flex; gap: 8px; margin-left: auto; flex-wrap: wrap;
}
.dp-sel-btn {
  display: flex; align-items: center; gap: 7px;
  padding: 7px 13px;
  border: 1.5px solid #e8e4e0;
  border-radius: 9px;
  background: transparent;
  font-size: 13px; color: #5a534f; cursor: pointer;
  transition: all .15s;
}
.dp-sel-btn:hover { border-color: #c8c0b8; }
.dp-checkbox {
  width: 16px; height: 16px;
  border-radius: 4px;
  border: 1.5px solid #d0c8c0;
  background: #fff;
  display: inline-flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
}
.dp-checkbox.on      { background: #ff825d; border-color: #ff825d; }
.dp-checkbox.partial { background: #ffd8c8; border-color: #ff825d; }

.dp-sel-all-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 7px 14px;
  background: #fff5f0;
  border: 1.5px solid #ffc8b0;
  border-radius: 9px;
  font-size: 13px; color: #c04820; cursor: pointer;
  font-weight: 500;
  transition: all .15s;
}
.dp-sel-all-btn:hover:not(:disabled) { background: #ffe8d8; }
.dp-sel-all-btn:disabled { opacity: .5; cursor: default; }
.dp-sel-all-btn strong { color: #c04820; }
.dp-spinner {
  width: 13px; height: 13px;
  border: 2px solid rgba(192,72,32,.3);
  border-top-color: #c04820;
  border-radius: 50%;
  animation: spin .6s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* BULK BAR */
.dp-bulk {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 28px;
  background: linear-gradient(180deg, #fff8f4 0%, #fff 100%);
  border-top: 1px solid #ffe0cc;
  flex-wrap: wrap;
}
.dp-bulk-left, .dp-bulk-center, .dp-bulk-right {
  display: flex; align-items: center; gap: 10px;
}
.dp-bulk-center { flex: 1; flex-wrap: wrap; }
.dp-bulk-pill {
  display: flex; align-items: center; gap: 8px;
  background: #ff825d; color: #fff;
  border-radius: 22px;
  padding: 6px 10px 6px 14px;
  font-size: 14px; font-weight: 500;
}
.dp-bulk-pill strong { font-size: 16px; font-weight: 800; }
.dp-bulk-x {
  background: none; border: none; cursor: pointer;
  color: rgba(255,255,255,.7); font-size: 12px;
  width: 20px; height: 20px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.dp-bulk-x:hover { background: rgba(255,255,255,.2); color: #fff; }

.dp-bulk-label { font-size: 13.5px; color: #7a736e; white-space: nowrap; }
.dp-bulk-pct {
  display: flex; align-items: center; gap: 4px;
  background: #fff;
  border: 1.5px solid #e8e4e0;
  border-radius: 9px;
  padding: 0 10px 0 0;
  overflow: hidden;
}
.dp-bulk-input {
  width: 56px; height: 36px;
  border: none; outline: none;
  font-size: 16px; font-weight: 700;
  text-align: center;
  padding: 0 8px;
  background: transparent;
  color: #1a1210;
}
.dp-bulk-pct span { font-size: 13px; color: #b0a8a0; }
.dp-bulk-pct:focus-within { border-color: #ff825d; }

.dp-bulk-rest { min-width: 180px; }
.dp-bulk-rest :deep(.el-input__inner) { border-radius: 9px !important; height: 36px !important; font-size: 13px !important; }

.dp-bulk-apply {
  display: flex; align-items: center; gap: 7px;
  padding: 9px 20px;
  background: #ff825d; color: #fff;
  border: none; border-radius: 10px;
  font-size: 14px; font-weight: 600; cursor: pointer;
  box-shadow: 0 2px 8px rgba(255,130,93,.35);
  transition: all .15s;
  white-space: nowrap;
}
.dp-bulk-apply:hover:not(:disabled) { background: #e86b45; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(255,130,93,.4); }
.dp-bulk-apply:disabled { opacity: .45; cursor: default; transform: none; box-shadow: none; }

.dp-slide-enter-active { transition: all .25s cubic-bezier(.22,.68,0,1.2); }
.dp-slide-leave-active { transition: all .18s ease; }
.dp-slide-enter, .dp-slide-leave-to { opacity: 0; transform: translateY(-8px); }

@media (max-width: 768px) {
  .dp-topbar, .dp-filters { padding: 14px 16px; }
  .dp-bulk { padding: 12px 16px; }
  .dp-brand-title { font-size: 15px; }
  .dp-hist-btn span { display: none; }
  .dp-bulk-center { flex-direction: column; align-items: flex-start; }
}
</style>
